import { http } from "./api";


export default class Decisorios {
  getPesquisarDecisorio(campoPesquisa) {
    return http.get(`/decisorios?strBusca=${campoPesquisa}`).then((res) => res.data).catch((err) => console.log(err))
  }

  getNaturezas() {
    return http.get(`/processo/naturezas`).then((res) => res.data).catch((err) => console.log(err))
  }

  getRelatores() {
    return http.get(`/processo/relatores`).then((res) => res.data).catch((err) => console.log(err))
  }

  adicionaZero(numero){
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }

  getDecisoriobyManyFields(termosConteudo, anoProcesso, numProcesso, anoDecisorio, numDecisorio, relatorDecisorio, orgaoJulgador, dataSessaoInicio, dataSessaoFim, natureza) {
    var dataInicio
    var dataInicioFormatada
    var dataFim
    var dataFimFormatada
    var naturezaFormatada
    var orgaoJulgadorFormatado
    var relatorDecisorioFormatado

    if (dataSessaoInicio != null) {
      dataInicio = new Date(dataSessaoInicio)
      dataInicioFormatada = (dataInicio.getFullYear() + "" + (this.adicionaZero(dataInicio.getMonth() + 1)) + "" + (this.adicionaZero(dataInicio.getDate()) ))
    } else
      dataInicioFormatada = "null"

    if (dataSessaoInicio != null) {
      dataFim = new Date(dataSessaoFim)
      dataFimFormatada = (dataFim.getFullYear() + "" + (this.adicionaZero(dataFim.getMonth() + 1)) + "" + (this.adicionaZero(dataFim.getDate()) ))
    } else
      dataFimFormatada = "null"

    if (natureza != null)
      naturezaFormatada = natureza.codigoNatureza
    else
      naturezaFormatada = "null"

    if (orgaoJulgador != null)
      orgaoJulgadorFormatado = orgaoJulgador.code
    else
      orgaoJulgadorFormatado = "null"

    if (relatorDecisorio != null)
      relatorDecisorioFormatado = relatorDecisorio.codigoRelator
    else
      relatorDecisorioFormatado = "null"

    return http.get(`/decisorios/byManyFields?strConteudo=${termosConteudo}&strAnoProcesso=${anoProcesso}&strNumeroProcesso=${numProcesso}&strAnoDecisorio=${anoDecisorio}&strNumeroDecisorio=${numDecisorio}&strRelatorDecisorio=${relatorDecisorioFormatado}&strOrgaoJulgador=${orgaoJulgadorFormatado.trim()}&strDataSessaoInicio=${dataInicioFormatada.trim()}&strDataSessaoFim=${dataFimFormatada.trim()}&strNatureza=${naturezaFormatada.trim()}`)
    .then((res) => res.data).catch((err) => console.log(err))
  }

  getDecisoriobyManyFieldsUrl(termosConteudo, anoProcesso, numProcesso, anoDecisorio, numDecisorio, codRelatorDecisorio, codOrgaoJulgador, dataSessaoInicio, dataSessaoFim, codNatureza) {
    var dataInicio
    var dataInicioFormatada
    var dataFim
    var dataFimFormatada
    var naturezaFormatada
    var orgaoJulgadorFormatado
    var relatorDecisorioFormatado

    // if (dataSessaoInicio != null) {
    //   dataInicio = new Date(dataSessaoInicio)
    //   dataInicioFormatada = (dataInicio.getFullYear() + "" + (this.adicionaZero(dataInicio.getMonth() + 1)) + "" + (this.adicionaZero(dataInicio.getDate()) ))
    // } else
    dataInicioFormatada = "null";

    // if (dataSessaoInicio != null) {
    //   dataFim = new Date(dataSessaoFim)
    //   dataFimFormatada = (dataFim.getFullYear() + "" + (this.adicionaZero(dataFim.getMonth() + 1)) + "" + (this.adicionaZero(dataFim.getDate()) ))
    // } else
    dataFimFormatada = "null";

    if (codNatureza != null)
      naturezaFormatada = codNatureza
    else
      naturezaFormatada = "null";

    if (codOrgaoJulgador != null)
      orgaoJulgadorFormatado = codOrgaoJulgador
    else
      orgaoJulgadorFormatado = "null";

    if (codRelatorDecisorio != null)
      relatorDecisorioFormatado = codRelatorDecisorio
    else
      relatorDecisorioFormatado = "null";

    return http.get(`/decisorios/byManyFields?strConteudo=${termosConteudo}&strAnoProcesso=${anoProcesso}&strNumeroProcesso=${numProcesso}&strAnoDecisorio=${anoDecisorio}&strNumeroDecisorio=${numDecisorio}&strRelatorDecisorio=${relatorDecisorioFormatado}&strOrgaoJulgador=${orgaoJulgadorFormatado.trim()}&strDataSessaoInicio=${dataInicioFormatada.trim()}&strDataSessaoFim=${dataFimFormatada.trim()}&strNatureza=${naturezaFormatada.trim()}`)
    .then((res) => res.data).catch((err) => console.log(err))
  }

}